export interface SharedProcessedFiles {
    [key: string]: string;
}
